import React from "react"
import PropTypes from "prop-types"

import FormController from "budde_utils/js/components/forms/FormController"
import {Box} from "core/js/components/presentation/container/box"
import {Heading} from "core/js/components/presentation/atoms/heading"
import {BaseButton as Button} from "core/js/components/presentation/atoms/button/base"
import {EmailInput} from "core/js/components/presentation/molecules/input/email"
import {Link} from "core/js/components/presentation/atoms/link"
import {BaseForm as Form} from "core/js/components/presentation/organisms/form/base"
import {FormBaseItem as FormItem} from "core/js/components/presentation/organisms/form/_item/base"
import {publish_screen} from "./publishers"


class RequestPasswordForm extends React.PureComponent {
    static propTypes = {
        url: PropTypes.func.isRequired,
    }

    state = {
        show_success_message: false,
    }

    show_login_form = event => {
        publish_screen({resetting_password: false})
        this.setState({show_success_message: false})
    }

    show_success_message = event => {
        this.setState({show_success_message: true})
    }

    render_success_message() {
        return <Box>
            <Heading two semantic
                style={{marginBottom: "1.5rem"}}
                color="white"
            >
                {gettext("Please check your inbox and click the link.")}
            </Heading>

            <Button pill
                color="dark"
                text={gettext("Return to login")}
                style={{
                    margin: "4rem auto 0.5rem auto",
                    display: "block",
                    width: "12rem",
                }}
                onClick={this.show_login_form}
            />
        </Box>
    }

    render_form() {
        const {url} = this.props
        return <React.Fragment>
                <Heading two semantic
                    style={{marginBottom: "1.5rem"}}
                    color="white"
                >
                    {gettext("No problem, we’ll send you a link. Please use it to change your password.")}
                </Heading>

                <FormController
                    endpoint={url("authentication:function-password_reset-api")}
                    subscribe_to="form_reset"
                    publish_to="form_reset"
                    key="password_reset"
                    config={{
                        init_component: (props) => (null),
                        on_error: (error, form_controller) => {
                            const {toggle} = form_controller.props
                            console.error(error)
                            setTimeout(toggle, 500)
                        },
                        form: {
                            component: (props) => (
                                <Form {...props}
                                    submit_button = {
                                        <React.Fragment>
                                            <Button primary pill
                                                input="submit"
                                                text={gettext("Reset password")}
                                                disabled={props.is_fetching}
                                                style={{
                                                    marginTop: "1rem",
                                                    marginBottom: "0.5rem",
                                                    marginRight: "0.5rem",
                                                    width: "12rem",
                                                }}
                                            />
                                            <Button pill
                                                color="dark"
                                                text={gettext("Return to login")}
                                                disabled={props.is_fetching}
                                                style={{
                                                    marginTop: "1rem",
                                                    marginBottom: "0.5rem",
                                                    marginLeft: "0.5rem",
                                                    width: "12rem",
                                                }}
                                                onClick={this.show_login_form}
                                            />
                                        </React.Fragment>
                                    }
                                />
                            ),
                            on_success: this.show_success_message,
                        },
                        widgets: {
                            field_widgets: {
                                email: {
                                    component: (props) => <FormItem
                                        {...props}
                                        label={gettext("Your Email")}
                                    />,
                                },
                                password: {
                                    component: (props) => null,
                                },
                            },
                        },
                        inputs: {
                            get_options: (options) => options,
                            field_inputs: {
                                email: {
                                    component: props => <EmailInput
                                        {...props}
                                        placeholder={gettext("name@example.de")}
                                        color="white"
                                    />,
                                },
                            },
                        },
                    }}
                />
            </React.Fragment>
    }

    render() {
        return (
            this.state.show_success_message
            ? this.render_success_message()
            : this.render_form()
        )
    }
}


export {RequestPasswordForm}
export default RequestPasswordForm
